import { createAsyncThunk } from '@reduxjs/toolkit';

export const postRequireMeeting = createAsyncThunk(
  'postRequireMeeting',
  async (
    data: {},
    { dispatch, extra, getState }: { dispatch: any; extra: any; getState: any }
  ) => {
    // if (!descriptif) {
    //   dispatch(
    //     addSnackMessage('negative', 'Le descriptif ne peut pas être vide')
    //   );
    //   return;
    // }
    // const postCustomerAskMeeting = dependencies.apiSlice.endpoints.postCustomerAskMeeting
    // postCustomerAskMeeting.initiate();
    // dispatch({
    //   type: actionTypes.POST_REQUIRING_MEETING,
    //   // payload: { currentProjectId },
    // });
  }
);
